import {
  Box,
  TextInput,
  Textarea,
  Button,
  Title,
  Stack,
  Flex,
  Text,
  Group,
} from '@mantine/core';
import { useState } from 'react';
import axios from 'axios';
import { ForeColorPurple } from '../../lib/constants';
import NotificationPopup from '../../components/NotifficationPopup';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useWindowScroll, useMediaQuery } from '@mantine/hooks';

function ContactUs() {
  const [form, setForm] = useState({
    email: '',
    subject: '',
    message: '',
  });

  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);
   const isMobile = useMediaQuery('(max-width: 768px)');

  const handleChange = (field) => (event) => {
    setForm({ ...form, [field]: event.currentTarget.value });
  };

  const showNotification = ({ type, message }) => {
    setNotification({ type, message: `This is a ${type} message.` });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.email || !form.subject || !form.message) {
      showNotification({
        title: 'Validation Error',
        message: 'Please fill in all fields.',
        type: "error",
      });
      return;
    }

    setLoading(true);

    try {
      await axios.post("https://uat-api.globalcomfortgroup.com.ph/api/v1/mailer/send", {
        to: 'inquiry@hotelsogo.com',
        subject: form.subject,
        html: `
          <div>
            <p>From: <strong>${form.email}</strong></p>
            <br/>
            <p>${form.message.replace(/\n/g, "<br />")}</p>
          </div>
        `,
      });

      showNotification({
        title: 'Message Sent',
        message: 'Your message has been sent successfully!',
        type: "success",
      });

      setForm({
        email: '',
        subject: '',
        message: '',
      });
    } catch (error) {
      console.error('Failed to send message:', error);
      showNotification({
        title: 'Sending Failed',
        message: 'Failed to send message. Please try again later.',
        type: 'error',
      });
    } finally {
      setLoading(false);
    }

  };

  return (
    <Box
      id="contactUs"
      w="100%"
      style={{
        backgroundColor: '#d50032',
        padding: isMobile? "20px":'100px',
        paddingTop: '150px'
      }}
    >

      <Flex
        direction={{ base: 'column', md: 'row' }}
        justify="center"
        align="stretch"
        gap="xl"
        mx="auto"
        style={{ maxWidth: '1200px' }}
      >
        {/* Left Column: Contact Form */}
        <Box
          w={{ base: '100%', md: '50%' }}
          p="lg"
          style={{ textAlign: 'left', color: 'white' }}
        >
          <Title order={2} align="left" mb={50}>
            Contact Us
          </Title>

          <Title order={4} mb="md" color={ForeColorPurple}>
            Global Comfort Group Corporation
          </Title>


          <Group align='center' mb='lg'>
            <Flex bg='white' w={50} h={50} align='center' justify='center' >
              <Icon icon="solar:phone-bold" color='#d50032' height={35} />
            </Flex>
            <Text size="md">
              <strong>Phone</strong><br />(02) 87900-966
            </Text>
          </Group>

          <Group align='center' mb='lg'>
            <Flex bg='white' w={50} h={50} align='center' justify='center' >
              <Icon icon="mdi:email" color='#d50032' height={35} width={35} />
            </Flex>
            <Text size="md">
              <strong>Email:</strong><br />inquiry@hotelsogo.com
            </Text>
          </Group>

          <Group align='start' mb='lg'>
            <Flex bg='white' w={50} h={50} align='center' justify='center' >
              <Icon icon="mingcute:building-2-fill" color='#d50032' height={35} width={35} />
            </Flex>

            <Text size="md">
              <strong>Address:</strong><br />
              #629 EDSA Cor, Aurora Blvd, Brgy. San Martin Porres<br />
              Quezon City, Metro Manila,<br />
              Philippines 1111
            </Text>
          </Group>
        </Box>


        {/* Right Column: Company Contact Info */}
        <Box
          w={{ base: '100%', md: '50%' }}
          bg="white"
          p="lg"
          style={{
            display: 'flex',
            justifyContent: 'center',
            borderRadius: '5px',
            boxShadow: '0px 20px 24px -12px #0000003d'
          }}
        >
          <Flex align='center' justify='center' style={{ width: '100%', maxWidth: '800px' }} p={40}>
            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
              <Stack spacing="md">
                <TextInput
                  label="Email"
                  placeholder="your@email.com"
                  value={form.email}
                  onChange={handleChange('email')}
                  required
                  styles={{
                    input: {
                      padding: "6px 12px",
                      height: 'unset'
                    }
                  }}
                />

                <TextInput
                  label="Subject"
                  placeholder="Subject"
                  value={form.subject}
                  onChange={handleChange('subject')}
                  required
                  styles={{
                    input: {
                      padding: "6px 12px",
                      height: 'unset'
                    }
                  }}
                />

                <Textarea
                  label="Message"
                  placeholder="Write your message..."
                  value={form.message}
                  onChange={handleChange('message')}
                  minRows={5}
                  rows={5}
                  required
                  styles={{
                    input: {
                      padding: "12px",
                      height: 'unset'
                    }
                  }}
                />

                <Button
                  type="submit"
                  radius="md"
                  size='lg'
                  fullWidth
                  loading={loading}
                  style={{
                    backgroundColor: ForeColorPurple,
                    color: 'white',
                    fontSize: '16px',
                    padding: '10px 0',
                  }}
                >
                  Send Message
                </Button>
              </Stack>
            </form>
          </Flex>
        </Box>

      </Flex>
      {notification && (
        <NotificationPopup
          type={notification.type}
          message={notification.message}
          onClose={() => setNotification(null)}
        />
      )}
    </Box>
  );
}

export default ContactUs;
